// extracted by mini-css-extract-plugin
export default {"root":"Settings_root__azHYf","actions":"Settings_actions__D2fIs","actions_content":"Settings_actions_content__GY8j6","action_content_root":"Settings_action_content_root__4zWhu"};